/** @jsxImportSource @emotion/react */
import { useTheme } from '@mui/material';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { notification } from '../../constants';
import { IPlainObject } from '../../models';
import { SignOut, usePopupAlertsReducer } from '../../store/reducers';

import { useDispatch } from 'react-redux';
import { SideBar, TopBar } from './components';
import { useMainLayoutStyles } from './MainLayout.styles';
import { useRemoveAuthTokenRequest } from './utils/useRemoveAuthTokenRequest';

export function MainLayout<P = IPlainObject>({
  children,
}: PropsWithChildren<P>): React.ReactElement {
  const theme = useTheme();
  const styles = useMainLayoutStyles(theme);
  const [{ data }, removeToken] = useRemoveAuthTokenRequest();
  const { showAlert } = usePopupAlertsReducer();
  const dispatch = useDispatch();

  const [openSidebar, setOpenSidebar] = useState(false);

  function handleSidebarOpen() {
    setOpenSidebar(true);
  }

  function handleSidebarClose() {
    setOpenSidebar(false);
  }

  useEffect(() => {
    if (!data) return;

    showAlert({
      content: notification.signedOutSuccessfully,
    });

    dispatch(new SignOut());
  }, [data]);

  return (
    <div css={styles} data-test-id="main-layout">
      <TopBar onSidebarOpen={handleSidebarOpen} onSignOut={removeToken} />
      <SideBar
        onClose={handleSidebarClose}
        open={openSidebar}
        onSignOut={removeToken}
      />
      <div className="wrapper" onClick={handleSidebarClose}>
        <div className="content-container">
          <div className="content" id="scrollable-container">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
